import React from "react";
import "./FetchingCard.css";
import logo from "../../assets/Images/Navbar/LoaderLogo.png";

export default function FetchingCard({
  // message = "Fetching details", 
  sub = "Please wait while we sync your data..."
}) {
  return (
    <div className="fetching-card2-container">
      <div className="global-loader-container">
        <div className="global-loader-wrapper">
          <div className="global-spinner"></div>
          <img src={logo} className="global-logo-loader" alt="loading" />
        </div>
      </div>
    </div>
  );
}

